"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
function ModCategoriesConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="animate-pulse rounded-md border border-border bg-muted/20">
            <AspectRatio ratio={16 / 9} />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-destructive">
        <p className="font-default text-lg">Kategoriler yüklenirken bir hata oluştu.</p>
      </div>;
  }
  if (!terms || terms.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p className="font-default text-lg">Henüz kategori bulunamadı.</p>
      </div>;
  }
  return <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {terms.map((term, i) => <Link key={term.id} to={term.link || "#"} data-index={i} className="group relative block overflow-hidden rounded-md border border-border bg-card transition-all duration-500 hover:border-primary hover:shadow-xl hover:shadow-primary/10">
          <AspectRatio ratio={16 / 9}>
            {term.image_url ? <img src={term.image_url} alt={term.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted/30">
                <span className="font-mono text-xs font-bold tracking-widest text-muted-foreground">
                  TÜR TOR TEKNİK
                </span>
              </div>}
            
            {}
            <div className="absolute inset-0 bg-secondary/10 transition-colors duration-500 group-hover:bg-primary/40" />
            
            {}
            <div className="absolute inset-0 flex items-center justify-center p-4">
              <div className="rounded-md border border-white/20 bg-secondary/80 px-6 py-3 backdrop-blur-sm transition-transform duration-500 group-hover:scale-105 group-hover:border-white/40 group-hover:bg-primary">
                <h3 className="font-default text-lg font-bold uppercase tracking-tight text-white">
                  {term.name}
                </h3>
                <div className="absolute -top-2 -right-2 hidden font-mono text-[10px] font-bold text-white/50 group-hover:block">
                  0{i + 1}
                </div>
              </div>
            </div>
            
            {}
            <div className="absolute bottom-0 left-0 right-0 translate-y-full bg-primary py-2 text-center transition-transform duration-300 group-hover:translate-y-0">
              <span className="font-mono text-[10px] font-bold uppercase tracking-widest text-white">
                Teknik Özellikleri İncele
              </span>
            </div>
          </AspectRatio>
        </Link>)}
    </div>;
}
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 4,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
export default function ModCategories() {
  return <section data-section-id="245736" id="ürün-kategorilerimiz" className="bg-background px-4 py-16 text-foreground sm:py-24">
      <div className="mx-auto mb-12 max-w-7xl text-center">
        <h2 className="font-default text-3xl font-bold uppercase tracking-tighter text-secondary sm:text-5xl">
          Ürün <span className="text-primary">Kategorilerimiz</span>
        </h2>
        <p className="mt-4 font-default text-lg text-muted-foreground">
          Butzbach GMBH mühendisliği ile üretilen yüksek performanslı endüstriyel kapı çözümleri
        </p>
      </div>

      <EcommerceTermsProvider className="mod-categories-wrapper" wp_term_query={wp_term_query}>
        <ModCategoriesConsumer />
      </EcommerceTermsProvider>
    </section>;
}